<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import { AuthTopHeader, TrustDossier } from '@modules/auth'
</script>

<template>
  <Box is="main" class="signup-shell" flex block>
    <Box class="signup-shell__left" direction="col">
      <AuthTopHeader />
      <Box class="signup-shell__body">
        <RouterView />
      </Box>
    </Box>
    <Box class="signup-shell__right">
      <TrustDossier />
    </Box>
  </Box>
</template>

<style scoped>
.signup-shell {
  height: 100dvh;
  overflow: hidden;
  background:
    radial-gradient(circle at 0% 0%, rgba(103, 85, 251, 0.06), transparent 35%),
    radial-gradient(circle at 100% 100%, rgba(103, 85, 251, 0.04), transparent 45%),
    var(--p-surface-50);
}

.signup-shell__left {
  flex: 1 1 52%;
  min-width: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
}

.signup-shell__right {
  flex: 1 1 48%;
  min-width: 360px;
  padding: 1rem;
  display: flex;
  align-items: stretch;
}

.signup-shell__body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overscroll-behavior: contain;
  scrollbar-width: none;
}

.signup-shell__body::-webkit-scrollbar {
  display: none;
}

@media (max-width: 992px) {
  .signup-shell {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .signup-shell__left {
    width: 100%;
  }

  .signup-shell__body {
    padding: 1.5rem 1rem;
    overflow: visible;
  }

  .signup-shell__right {
    display: none;
  }
}
</style>
